export const DIAS_SEMANA = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
export const MESES = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
];

// Lunes de la semana a la que pertenece la fecha dada
export function lunesDeSemana(fecha = new Date()) {
  const d = new Date(fecha);
  const dia = (d.getDay() + 6) % 7; // 0 = lunes
  d.setDate(d.getDate() - dia);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function sumarDias(fecha, dias) {
  const d = new Date(fecha);
  d.setDate(d.getDate() + dias);
  return d;
}

// 'YYYY-MM-DD' en hora local
export function aISO(fecha) {
  const y = fecha.getFullYear();
  const m = String(fecha.getMonth() + 1).padStart(2, '0');
  const d = String(fecha.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function desdeISO(iso) {
  return new Date(`${iso}T00:00:00`);
}

// '07:00:00' → '7:00 am'
export function horaLegible(hora) {
  const [h, m] = hora.split(':').map(Number);
  const sufijo = h < 12 ? 'am' : 'pm';
  const hora12 = h % 12 === 0 ? 12 : h % 12;
  return `${hora12}:${String(m).padStart(2, '0')} ${sufijo}`;
}

// '2026-07-04' → '4 de julio'
export function fechaLegible(iso) {
  const d = desdeISO(iso);
  return `${d.getDate()} de ${MESES[d.getMonth()]}`;
}

export function fechaCompleta(iso) {
  const d = desdeISO(iso);
  return `${DIAS_SEMANA[(d.getDay() + 6) % 7]} ${d.getDate()} de ${MESES[d.getMonth()]}`;
}

export function esHoy(iso) {
  return iso === aISO(new Date());
}
